import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import type { PageData } from './types';

const pageDataEl = document.getElementById('pageData');
if (!pageDataEl) { throw new Error('Missing #pageData element'); }
const pageData: PageData = JSON.parse(pageDataEl.textContent!);

const container = document.getElementById('application-form-root')!;
const root = ReactDOM.createRoot(container);
root.render(React.createElement(App, pageData));

if (module.hot) { module.hot.accept(); }
